import { useState } from "react";
import "./gallery.css";

import Img1 from "../../../Assets/Images/home/g1.png";
import Img2 from "../../../Assets/Images/home/g2.png";
import Img3 from "../../../Assets/Images/home/g3.png";
import Img4 from "../../../Assets/Images/home/g4.png";
import Img5 from "../../../Assets/Images/home/g5.png";
import Img6 from "../../../Assets/Images/home/g6.png";

const Gallery = () => {
  const images = [Img1, Img2, Img3, Img4, Img5, Img6];
  const [selected, setSelected] = useState(null);

  return (
    <section className="gallery-section brightness">
      <div className="container">
        <h2 className="gallery-title">On The Court With Us</h2>
        <p className="gallery-sub">
          Where skills, fun, and teamwork come alive.
        </p>

        <div className="masonry">
          {images.map((img, i) => (
            <div
              key={i}
              className="masonry-item"
              onClick={() => setSelected(img)}
            >
              <img src={img} alt="" />
            </div>
          ))}
        </div>

        {selected && (
          <div className="popup" onClick={() => setSelected(null)}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <img src={selected} alt="" />
              <span className="popup-close" onClick={() => setSelected(null)}>
                ×
              </span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
